<template>
  <section class="TcEventShow flex items-center justify-center">
    <div class="w-11/12 bg-white text-gray-900">
      <article>
        <TcEventItem :event="$props.event" hide_info="false" :subscribed="subscribed" class="mb-10"></TcEventItem>
        <div class="w-4/6 mx-auto">
          <div class="flex w-full gap-3 mb-3">
            <div class="transport flex-1 flex gap-2 p-3 rounded-lg items-center text-center bg-gray-100">
              <TcIcon :icon="event.check_bus?'ok':'cross'" class="rounded-full text-white h-5 w-5"
                :class="{'bg-green-600':event.check_bus, 'bg-red-300':!event.check_bus}"></TcIcon>
              <TcIcon icon="bus" class="rounded-full text-gray-900 h-5 w-5"></TcIcon>
              <span>Guagua</span>
            </div>
            <div class="companions flex-1 flex gap-2 p-3 rounded-lg items-center text-center bg-gray-100">
              <TcIcon :icon="event.allow_companions?'ok':'cross'" class="rounded-full text-white h-5 w-5"
                :class="{'bg-green-600':event.allow_companions, 'bg-red-300':!event.allow_companions}"></TcIcon>
              <TcIcon icon="group" class="rounded-full text-gray-900 h-5 w-5"></TcIcon>
              <span>Acompañante</span>
            </div>
            <div class="guests flex-1 flex gap-2 p-3 rounded-lg items-center text-center bg-gray-100">
              <TcIcon :icon="event.allow_guests?'ok':'cross'" class="rounded-full text-white h-5 w-5"
                :class="{'bg-green-600':event.allow_guests, 'bg-red-300':!event.allow_guests}"></TcIcon>
              <TcIcon icon="group" class="rounded-full text-gray-900 h-5 w-5"></TcIcon>
              <span>Invitados</span>
            </div>
          </div>
          <div class="observaciones py-5 px-2 mb-3 rounded-lg bg-gray-100">
            <h3 class="flex items-center">
              <TcIcon icon="list-ul" class="h-6 w-6 mr-3"></TcIcon>
              <span class="font-semibold">Observaciones</span>
            </h3>
            <div v-if="extra_info" v-html="extra_info.description" class="pl-9 pr-3 mt-2 overflow-x-hidden overflow-y-auto" style="max-height: 140px;"></div>
          </div>
          <div class="flex w-full gap-3 mb-3">
            <div class="start_date flex-1 text-left rounded-lg bg-gray-100 py-3 pl-2">
              <h3 class="flex items-center">
                <TcIcon icon="calendar" class="h-6 w-6 mr-3"></TcIcon>
                <span class="font-semibold">Fechas</span>
              </h3>
              <div class="pl-9 pr-3 mt-2">
                <div class="mb-2">
                  <span class="font-medium">Fecha evento:</span>
                  <div class="font-bold" v-if="date_time">{{ date_time.toLocaleString('es-ES',{month:'short', day:'numeric', year:'numeric'}) }}</div>
                  <div class="font-bold" v-if="date_time">{{ date_time.toLocaleString('es-ES',{hour:'numeric', minute:'numeric', hour12: true}) }}</div>
                </div>
                <div>
                  <span class="font-medium">Inscripción hasta:</span>
                  <div class="font-bold" v-if="extra_info">{{ extra_info.end_registration }}</div>
                </div>
              </div>
            </div>
            <div class="amount flex-1 text-left rounded-lg bg-gray-100 py-3 pl-2">
              <h3 class="flex items-center">
                <TcIcon icon="coin" class="h-6 w-6 mr-3"></TcIcon>
                <span class="font-semibold">Precio</span>
              </h3>
              <div class="pl-9 pr-3 mt-2">
                <div>Estándar: <strong>{{ event.amount.strToEuro() }}</strong></div>
                <div>Desempleado: <strong>{{ event.amount_for_unemployed.strToEuro() }}</strong></div>
                <div>Acompañante: <strong>{{ event.companions_amount.strToEuro() }}</strong></div>
              </div>
            </div>
          </div>
          <div class="flex w-full gap-3 mb-3">
            <div class="company flex-1 text-left rounded-lg bg-gray-100 flex p-3 gap-3">
              <TcIcon icon="company" class="h-6 w-6"></TcIcon>
              <div>
                <div class="font-semibold">Empresa</div>
                <div v-if="extra_info" class="font-light">{{ extra_info.company }}</div>
              </div>
            </div>
            <div class="speaker flex-1 text-left rounded-lg bg-gray-100 flex p-3 gap-3">
              <TcIcon icon="user-circle-solid" class="h-6 w-6"></TcIcon>
              <div>
                <div class="font-semibold">Ponente</div>
                <div class="font-light">{{ event.speaker }}</div>
              </div>
            </div>
            <div class="organizer flex-1 text-left rounded-lg bg-gray-100 flex p-3 gap-3">
              <TcIcon icon="library" class="h-6 w-6"></TcIcon>
              <div>
                <div class="font-semibold">Organiza</div>
                <div class="font-light">{{ event.host_name }}</div>
              </div>
            </div>
          </div>
          <div class="flex w-full gap-3 mt-10 mb-5">
            <button @click="closeModal" class="flex-1 btn-secondary btn-sm">Cerrar</button>
            <button v-if="!subscribed" @click="subscribeEvent(event)" class="flex-1 btn-sm">Inscribirme</button>
            <span v-else class="flex-1 btn-sm text-center font-bold text-green-500"> Ya inscrito </span>
          </div>
        </div>
      </article>
    </div>
  </section>
</template>

<script>
import TcIcon from './TcIcon.vue';
import TcEventItem from './TcEventItem.vue'; //type: ignore
import eventsMixin from '../mixin/eventsMixin';

export default {
  name: 'TcEventShow',
  props: ['event'],
  components: {
    TcEventItem,
    TcIcon,
  },
  data () {
    return {
      extra_info: null,
      date_time: null,
    }
  },
  mixins: [
    eventsMixin,
  ],
  computed: {
    subscribed: function() {
      return this.IsSubscribed(this.event);
    },
  },
  methods: {
    closeModal: function() {
      this.$parent.selected_event = null;
    },
    subscribeEvent: function (c_event) {
      this.$parent.subscribeEvent(c_event);
    }
  },
  mounted() {
    //console.log("mounted TcEventShow", this);
    this.loadMyEvents();
    this.date_time = new Date(this.$props.event.start_date_default);
    let url = `${this.$root.events_url()}/${this.$props.event.id}`;
    if (this.$root.access_token) {
      url += `?access_token=${encodeURIComponent(this.$root.access_token)}`;
    }
    //console.log('URL', url);
    fetch(url).then(response => response.json())
    .then(json => {
      //console.log('TcEventShow DATA', json);
      this.extra_info = json;
    }).catch(err => {
      console.error('SE HA PRODUCIDO UN ERROR EN TcEventShow', err);
    });
  },
}
</script>